/**
 * Front JS
 */

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

/**
 * Import styles
 */
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.custom-slider').forEach((slider) => {

        const baseSlides = parseInt(slider.dataset.slides, 10) || 1;
        const speed = parseInt(slider.dataset.speed, 10) || 3000;

        new Swiper(slider.querySelector('.swiper'), {
            modules: [Navigation, Pagination, Autoplay],
 /**
 *  RESPONSIVE BREAKPOINTS
 */
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                640: {
                    slidesPerView: Math.min(2, baseSlides),
                },
                1024: {
                    slidesPerView: baseSlides,
                }
            },

            loop: slider.dataset.loop === 'true',

            autoplay: slider.dataset.autoplay === 'true'
                ? { delay: speed, disableOnInteraction: false }
                : false,

            navigation: slider.dataset.navigation === 'true'
                ? {
                      nextEl: slider.querySelector('.swiper-button-next'),
                      prevEl: slider.querySelector('.swiper-button-prev'),
                  }
                : false,

            pagination: slider.dataset.pagination === 'true'
                ? {
                      el: slider.querySelector('.swiper-pagination'),
                      clickable: true,
                  }
                : false,

            spaceBetween: 10,

         
            observer: true,
            observeParents: true,
            resizeObserver: true,
        });
    });
});